/* eslint-disable import/prefer-default-export */
const interfaceTypes = {
	desktop: 1,
	mobile: 2
};

export { interfaceTypes };
